import { morphism } from 'morphism'
import { formatDate } from 'tfs.front-end-utils/dates'

import constants from '../config/constants'

import seatCountSchema from './seatCount'
import flightSchema from './flight'

import SeatCountModel from '../models/SeatCount'
import FlightModel from '../models/Flight'

import { moment } from '../utils/dates'

/**
 * (Pre)Format the flight info
 * @param {Object} flightInfo
 * @returns {Object}
 */
const formatFlightInfo = flightInfo => {
  const { arrival, arrivalUtc, departure, departureUtc } = flightInfo

  const renamedTimesProperties = {
    sta: arrival,
    staUtc: arrivalUtc,
    std: departure,
    stdUtc: departureUtc,
  }

  const preFormattedFlightInfo = {
    ...flightInfo,
    ...renamedTimesProperties,
  }

  return morphism(flightSchema, preFormattedFlightInfo, FlightModel)
}

/**
 * Format the items of a search query
 * @param {Object} SearchQuery
 * @returns {Object}
 */
const items = ({ items = [] }) => {
  return items.map(
    ({ flightInfo = {}, travelClassSeatCounts = [], flightId }) => {
      const formatSeatCount = seatCount =>
        morphism(seatCountSchema, seatCount, SeatCountModel)

      return {
        flightId,
        flightInfo: flightInfo ? formatFlightInfo(flightInfo) : {},
        travelClassSeatCounts: travelClassSeatCounts.map(formatSeatCount),
      }
    }
  )
}

/**
 * Format the departure date
 * @param {Object} SearchQuery
 * @returns {String}
 */
const departureDate = ({ departureDate }) => {
  return formatDate(
    moment,
    departureDate,
    constants.backEndDateFormat,
    constants.dateIncludingDay
  )
}

export default {
  arrivalAirport: 'arrivalAirport',
  departureAirport: 'departureAirport',
  departureDate,
  order: 'order',
  route: 'route',
  items,
}
